// IMP-254: partner branding for white-labeled auth pages. Present only when the
// app is reached on a partner subdomain; null otherwise (pages fall back to
// Imperative copy and render no logo).
export interface PartnerBranding {
  name: string
  logo_url: string | null
  logo_wordmark_url: string | null
}

// Renders the partner logo at the top of the auth panel, or nothing when there
// is no partner / no logo. Priority: logo_url -> logo_wordmark_url -> none.
export default function PartnerAuthLogo({
  partner,
}: {
  partner?: PartnerBranding | null
}) {
  const src = partner?.logo_url ?? partner?.logo_wordmark_url
  if (!partner || !src) return null

  return (
    <img
      src={src}
      alt={partner.name}
      className="mx-auto mb-2 h-12 w-auto object-contain"
    />
  )
}
